
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { useSport } from '../../../context/SportContext';
import { getAllSportList } from '../../../services/commonApiService/CommonApiService';
const SportFilter = ({ className = " ", required, setCurrentPage, disabled = false, value, onChange }) => {
    const [sportsList, setSportsList] = useState([]);

    // Safely attempt to use context, fallback to null if not inside provider
    const context = useSport();
    const { selectedSportId, setSelectedSportId } = context || {};


    useEffect(() => {
        const fetchSportsList = async () => {
            try {
                const response = await getAllSportList();
                setSportsList(response?.data?.data || []);
            } catch (error) {
                console.error('Error fetching sports list:', error);
            }
        };

        fetchSportsList();
    }, []);

    const handleChange = (e) => {
        const selectedId = e.target.value;

        // If external onChange is provided, use it
        if (onChange) {
            onChange(e);
        } else if (setSelectedSportId) {
            // Otherwise use context if available
            setSelectedSportId(selectedId);
        }

        if (setCurrentPage) {
            setCurrentPage(1);
        }
    };

    // Use prop value if provided, otherwise context value, otherwise default
    const currentValue = value !== undefined ? value : (selectedSportId || "");
    return (
        <>
            <div>
                <Form.Select
                    value={currentValue}
                    onChange={handleChange}
                    className={`me-2 ${className}`}
                    style={{ width: '100%', padding: "11px 50px 10px 11px" }}
                    required={required}
                    disabled={disabled}
                >
                    <option value="">All Sports</option>
                    {sportsList.map((item) => (
                        <option key={item.id} value={item?.sport_id}>
                            {item.sport_name}
                        </option>
                    ))}
                </Form.Select>
            </div>
        </>
    )
}

export default SportFilter